import axiosImport from 'axios';

const savedCompanyId = localStorage.getItem('companyId');

const axios = axiosImport.create();
axios.defaults.params = {
  companyId: savedCompanyId ? Number(savedCompanyId) : 0,
};

export default axios;
